import { getEditLocation } from "../../../core/util/functions";

export const whsLocation = "/listing/codebook/warehouses";
export const getWhsEditLocation = (id?: string) => getEditLocation(whsLocation, undefined, id);

export const editRouter = getWhsEditLocation(":whsId?");
